import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContentfulState } from ".";

const initialState: ContentfulState = {
  data: null,
  loading: false,
};

export const contentfulSlice = createSlice({
  name: "contentful",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setContentful: (state, action) => {
      state.data = action.payload;
    },
  },
});

const contentfulReducer = contentfulSlice.reducer;

export const contentfulActions = contentfulSlice.actions;
export default contentfulReducer;
